import { createAsyncThunk } from "@reduxjs/toolkit"
import { setFollowingEntity } from "plugins/shared/playback/state/slice"
import { Project } from "@nova/protobuf"
import { get } from "nodash"
import { Socket } from "socket.io-client"
import { ProjectWithMetadata } from "@nova/constants"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectFireById } from "features/entity-caching/fires/selectors"
import { getRegion } from "@nova/util-browser"
import { createAppAsyncThunk } from "integrations/redux/hooks"
import { Location } from "@nova/schemas"

export const loadProject = createAsyncThunk<
    ProjectWithMetadata,
    { projectId: string; orgId: string }
>("fires/loadProject", async (payload, api) => {
    const { projectId, orgId } = payload
    // redux middleware appends the socket to this particular payload, jank but idk how else to do this
    const socket = get(payload, "socket") as unknown as Socket
    // re-establish handshake so the future load balancer can send traffic to the correct machine
    socket.auth = {}
    socket.disconnect()
    await new Promise<void>((resolve) => {
        if (!socket.connected) {
            resolve()
        } else {
            socket.once("disconnect", () => resolve())
        }
    })
    socket.auth = { projectId, orgId }
    socket.connect()
    try {
        await new Promise<void>((res, rej) => {
            socket.once("connected", res)
            socket.once("connection_failed", rej)
        })
    } catch (err) {
        console.error(err)
        api.rejectWithValue("Could not connect to socket")
    }
    socket.on("fatal", () => socket.disconnect())
    const res = await fetch(`/api/protobuf/org/${orgId}/project/${projectId}`, {
        headers: { "Cache-Control": "no-cache" },
    })
    const pb = await res.arrayBuffer()
    const project = Project.decode(new Uint8Array(pb))
    return { ...project, region: getRegion(), orgId, id: projectId }
})

export const loadAndZoomProject = createAppAsyncThunk<
    Location | undefined,
    { projectId: string; orgId: string }
>("fires/loadAndZoomProject", async (payload, api) => {
    const { orgId, projectId } = payload
    api.dispatch(setFollowingEntity(undefined))
    await api.dispatch(loadProject({ orgId, projectId })).unwrap()

    const state = api.getState()
    const project = selectFireById(projectId)(state)
    const thumbnailViewState = project?.thumbnailViewState

    if (thumbnailViewState) return thumbnailViewState

    const workspace = selectActiveWorkspace()(state)
    if (workspace?.location) return workspace.location
})
